import { Controller } from "@hotwired/stimulus"

// Time left until a moment, kept current on the page: "2h 14m", then "40m",
// then the last minute counted in seconds. Used for the disappearing rail
// and the edit window. Says `done` once the moment has passed. The page may
// hand it the unit letters in the reader's language (`units`: s, m, h, d).
export default class extends Controller {
  static targets = ["left"]
  static values = {
    until: String,
    done: { type: String, default: "gone" },
    units: { type: Object, default: { s: "s", m: "m", h: "h", d: "d" } }
  }

  connect() {
    this.until = new Date(this.untilValue).getTime()
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const seconds = Math.floor((this.until - Date.now()) / 1000)
    const text = seconds <= 0 ? this.doneValue : this.words(seconds)
    const targets = this.hasLeftTarget ? this.leftTargets : [this.element]
    targets.forEach((target) => { if (target.textContent !== text) target.textContent = text })
    if (seconds <= 0) {
      clearInterval(this.timer)
      this.element.classList.add("countdown-done")
    }
  }

  words(seconds) {
    const { s, m, h, d } = this.unitsValue
    if (seconds < 60) return `${seconds}${s}`
    const minutes = Math.floor(seconds / 60)
    if (minutes < 60) return `${minutes}${m}`
    const hours = Math.floor(minutes / 60)
    if (hours < 24) return minutes % 60 && hours < 6 ? `${hours}${h} ${minutes % 60}${m}` : `${hours}${h}`
    const days = Math.floor(hours / 24)
    return hours % 24 && days < 3 ? `${days}${d} ${hours % 24}${h}` : `${days}${d}`
  }
}
